module.exports = __webpack_public_path__ + "img/infografica-img-03.b9e387d1.png";